import { createGlobalStyle } from 'styled-components';

import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-datepicker/dist/react-datepicker.css';

import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Poppins:wght@400;500|Roboto|Montserrat:wght@400;500|Titillium+Web&display=swap');

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  *:focus {
    outline: 0;
  }


  html, body, #root {
    height: 100%;
    background: #111;
  }

  body {
    -webkit-font-smoothing: antialiased;
  }

  body, input, button {
    font: 14px 'Montserrat' , sans-serif;
  }

  a {
    text-decoration: none;
  }

  ul {
    list-style: none;
  }



  button {
    cursor: pointer;
  }
`;
